import portfolio from './portfolio.json'
import { currentLocale, type Locale } from '../locales'

export interface LocalizedString {
  'pt-BR': string
  en: string
}

export interface Metric {
  value: number
  prefix?: string
  suffix?: string
  staticText?: LocalizedString
  label: LocalizedString
}

export interface ExperienceBullet {
  'pt-BR': string
  en: string
}

export interface ExperienceRole {
  title: LocalizedString
  period: string
  bullets: ExperienceBullet[]
}

export interface ExperienceEntry {
  company: string
  location: LocalizedString
  period: string
  roles: ExperienceRole[]
}

export interface ProjectItem {
  title: string
  description: LocalizedString
  repository: string
  url: string
  img: string
  tags: string[]
  isNew: boolean
  featured?: boolean
  accent?: string
  status?: LocalizedString
}

export interface ProfileFact {
  label: LocalizedString
  value: LocalizedString
}

export interface Profile {
  name: LocalizedString
  role: LocalizedString
  summary: LocalizedString
  facts: ProfileFact[]
}

export interface StackItem {
  title: string
  description: LocalizedString
  img: string
  url: string
  category: string
}

interface Portfolio {
  profile: Profile
  metrics: Metric[]
  experience: ExperienceEntry[]
  projects: ProjectItem[]
  stack: StackItem[]
}

const data = portfolio as unknown as Portfolio

export const profile: Profile = data.profile
export const metrics: Metric[] = data.metrics
export const experience: ExperienceEntry[] = data.experience
export const projects: ProjectItem[] = data.projects
export const stack: StackItem[] = data.stack

export function loc(text: LocalizedString, locale?: Locale): string {
  return text[locale ?? currentLocale()] ?? text.en
}
